import axios from "axios";
import { header } from "./header";
const url = "https://production-api-dot-bacpoint.uc.r.appspot.com";
// const url = "https://bacpoint.uc.r.appspot.com";

const endpoins = {
  allUsers: "/api/getAllUsersData",
  userGender: "/api/UserGender",
  userAges: "/api/UserAges",
  averageAuditC: "/api/averageAuditC",
  averageBingeSessions: "/api/getBingeDrinkSessions",
  averageSessions: "/api/getAdminDrinkSessions",
  signIn: "/api/loginDoctor",
  breathalizer: "/api/getBactrakDataMonthly/",
  allPendingUsers: "/api/getAllPendingUsersData",
  addPendingUser: "/api/addPendingUser",
  signupDoctor: "/api/signupDoctor",
  getMonthlyBACandDrinks: "/api/getMonthlyBACandDrinks",
  checkInviteCode: "/api/inviteCodeUnique",
  allAssessments: "/api/assessments",
  addTemplate: "/api/assessmentTemplates",
  getAssessmentsByUser: "/api/getAssessmentsByUser",
  sendAllAssessments: "/api/sendAssessmentAllUsers/",
  sendAllSpecificUsers: "/api/sendAssessmentAllSpecificUsers",
  getSessionLog: "/api/sessionLog/",
  addSessionLog: "/api/addSessionLog",
  breathalyzerModalDailyActivity: "/api/breathalyzerModalDailyActivity",
  breathalyzerModalAverages: "/api/breathalyzerModalAverages",
  greenMonthlyReadings: "/api/greenMonthlyReadings",
};

const year = new Date().getFullYear();
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getGreenMonthlyReadingsApi = async (id, monthIndex) => {
  const local_url = `${url}${endpoins.greenMonthlyReadings}?monthIndex=${monthIndex}&year=${year}&user=${id}&timezone=${timezone}`;
  try {
    const res = await axios.get(local_url, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const getBreathalyzerModalAveragesApi = async (id, monthIndex) => {
  const local_url = `${url}${endpoins.breathalyzerModalAverages}?monthIndex=${monthIndex}&year=${year}&user=${id}&timezone=${timezone}`;
  try {
    const res = await axios.get(local_url, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const getBreathalyzerModalDailyActivityApi = async (id) => {
  const local_url = `${url}${endpoins.breathalyzerModalDailyActivity}?user=${id}&timezone=${timezone}`;
  try {
    const res = await axios.get(local_url, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const sendAllAssessments = async (bodyData) => {
  try {
    const res = await axios.post(
      url + endpoins.sendAllAssessments + doctorId,
      bodyData,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    return {
      error: err,
      message: err.response.data.message,
    };
  }
};

export const sendAllSpecificUsers = async (bodyData) => {
  try {
    const res = await axios.post(
      url + endpoins.sendAllSpecificUsers,
      bodyData,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    return {
      error: err,
      message: err.response.data.message,
    };
  }
};

export const addSessionLogApi = async (bodyData) => {
  try {
    const res = await axios.post(url + endpoins.addSessionLog, bodyData, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    return {
      error: err,
      message: err.response.data.message,
    };
  }
};

export const getSessionLogApi = async (id) => {
  try {
    const res = await axios.get(url + endpoins.getSessionLog + id, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const getUserAssessment = async (id) => {
  try {
    const res = await axios.get(
      url + endpoins.getAssessmentsByUser + "?id=" + id + "&sort=true",
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const getTemplateAPI = async (id) => {
  try {
    const res = await axios.get(url + endpoins.addTemplate + "/" + id, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const updateTemplateAPI = async (props) => {
  try {
    const res = await axios.patch(
      url + endpoins.addTemplate + "/" + props._id,
      props.body,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const allTemplatesAPI = async () => {
  try {
    const res = await axios.get(url + endpoins.addTemplate, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const addAssessmentsAllAPI = async (data) => {
  try {
    const res = await axios.post(url + endpoins.allAssessments, data, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const addAssessmentsAPI = async (data) => {
  try {
    const res = await axios.post(url + endpoins.allAssessments, data, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const addTemplateAPI = async (data) => {
  try {
    const res = await axios.post(url + endpoins.addTemplate, data, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const checkInviteCodeApi = async (bodyData) => {
  try {
    const res = await axios.post(url + endpoins.checkInviteCode, bodyData, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    return {
      error: err,
      message: err.response.data.message,
    };
  }
};

export const getMonthlyBACandDrinksApi = async (user) => {
  try {
    const res = await axios.get(
      url + endpoins.getMonthlyBACandDrinks + "?user=" + user,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const signupDoctorApi = async (bodyData) => {
  try {
    const res = await axios.post(url + endpoins.signupDoctor, bodyData, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};
export const addPendingUserApi = async (userData) => {
  try {
    const res = await axios.post(url + endpoins.addPendingUser, userData, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    return {
      error: err,
      message: err.response.data.message,
    };
  }
};

export const signInApi = async (data) => {
  try {
    const response = await axios.post(url + endpoins.signIn, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const addNewUserApi = async (userData) => {
  try {
    const response = await fetch("YOUR_API_ENDPOINT", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Include other headers like authorization if needed
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json(); // or return true if your API doesn't send back the new user
  } catch (error) {
    console.error("Error in addNewUserApi:", error);
    throw error;
  }
};

export const breathalizerApi = async (id) => {
  let newUrl = `${url}${endpoins.breathalizer}${id}`;
  try {
    const res = await axios.get(newUrl, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const npiNumberApi = async (number) => {
  let newUrl = `https://clinicaltables.nlm.nih.gov/api/npi_org/v3/search?terms=${number}`;
  try {
    const response = await axios.get(newUrl);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const averageSessionsApi = async (props) => {
  let parameter = "";
  if (props.gender === "male") {
    parameter = "gender=male";
  } else if (props.gender === "female") {
    parameter = "gender=female";
  } else if (props.ageMin > 0) {
    parameter = "age=" + props.ageMin + "-" + props.ageMax;
  }

  let message = url + endpoins.averageSessions + "?" + parameter;
  try {
    const res = await axios.get(
      url + endpoins.averageSessions + "?" + parameter,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const averageBingeSessionsApi = async (props) => {
  let parameter = "type=average&";
  if (props.gender === "male") {
    parameter += "gender=male";
  } else if (props.gender === "female") {
    parameter += "gender=female";
  } else if (props.ageMin > 0) {
    parameter += "age=" + props.ageMin + "-" + props.ageMax;
  }

  let message = url + endpoins.averageBingeSessions + "?" + parameter;
  try {
    const res = await axios.get(
      url + endpoins.averageBingeSessions + "?" + parameter,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const averageAuditCApi = async (props) => {
  let parameter = "";
  if (props.gender === "male") {
    parameter = "gender=male";
  } else if (props.gender === "female") {
    parameter = "gender=female";
  } else if (props.ageMin > 0) {
    parameter = "age=" + props.ageMin + "-" + props.ageMax;
  }

  let message = url + endpoins.averageAuditC + "?" + parameter;
  try {
    const res = await axios.get(
      url + endpoins.averageAuditC + "?" + parameter,
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const allUsersApi = async () => {
  try {
    const res = await axios.get(
      url + endpoins.allUsers + "?page=0&rowsPerPage=1000",
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const allPendingUsersApi = async () => {
  try {
    const res = await axios.get(
      url + endpoins.allPendingUsers + "?page=0&rowsPerPage=1000",
      {
        headers: header,
      }
    );
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const userGenderApi = async () => {
  try {
    const res = await axios.get(url + endpoins.userGender, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};

export const userAgesApi = async () => {
  try {
    const res = await axios.get(url + endpoins.userAges, {
      headers: header,
    });
    return res.data;
  } catch (err) {
    console.error({ err });
  }
};
